import { render, staticRenderFns } from "./EnableNsfwModal.vue?vue&type=template&id=6615375e&"
import script from "./EnableNsfwModal.vue?vue&type=script&lang=ts&"
export * from "./EnableNsfwModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports